export default {
  titleFontSizeSmall: '26px',
  titleFontSizeMedium: '32px',
  titleFontSizeLarge: '40px',
  titleFontSizeHuge: '48px',
  fontSizeSmall: '14px',
  fontSizeMedium: '14px',
  fontSizeLarge: '15px',
  fontSizeHuge: '16px',
  iconSizeSmall: '64px',
  iconSizeMedium: '80px',
  iconSizeLarge: '100px',
  iconSizeHuge: '125px',
  iconColor418: undefined,
  iconColor404: undefined,
  iconColor403: undefined,
  iconColor500: undefined
}
